import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& .header": {
      fontSize: "32px"
    }
  }
}));
export default function ErrorFallback() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography
        className="header"
        component={"h1"}
        variant="h1"
        dangerouslySetInnerHTML={{
          __html: "An error occurred, our team has been notified."
        }}
      />
    </div>
  );
}
